module.exports = __webpack_public_path__ + "assets/img/b45fa6cc2020d3e337b96dba40cd1205.svg";